import Service from "./Service";
import {
  AmendBerthEntity,
  AmendPolicyEntity,
  AmendRateEntity,
  AmendTimeEntity,
  ClientCodeEntity,
  ClientUserEntity,
  CustomerLevelEntity,
  DisableProduct,
  ExtraInfoEntity,
  FlightGoodsEntity,
  FlightOptionsEntity,
  PolicyFrequency,
  FlightPolicyEntity,
  ProductEntity,
  FlightProductEntity,
  LevelInfoEntity,
  AirwayModel,
  AirportModel,
  CityModel,
  FlightResult,
  SearchModel,
  FlightModel,
  StopModel,
  BerthModel,
  Passenger,
  PriceModel,
  FlightSearchResult,
  RuleModel,
  RuleInfo,
  PolicyInfoEntity,
  SearchPolicyModel,
  PassPrice,
  QueryPolicyModel,
  PolicyThrowEntity,
} from "@/model/FlightPolicy";
import { PageList } from "@/model/system";
import { ProductResult } from "@/model/Policy";

class FlightPolicyService extends Service {
  getFlightLists(data: FlightSearchResult) {
    return this.post<PageList<FlightSearchResult>>(`/FlightSearch/Search`, data);
  }
  SaveFlight(data: FlightSearchResult) {
    return this.post<number>(`/FlightSearch/SaveFlight`, data);
  }
  getProductInfo(data: any) {
    return this.post<FlightPolicyEntity[]>(`/FlightPolicy/ProductInfo`, data);
  }
  SearchAmendPolicy(id: string, applyarea: any) {
    // return $http.get(this.getUrl(`/AmendPolicy/GetAmendPolicy?id=${id}&ApplyArea=${applyarea}`), {
    //   failTips: false
    // })
    return this.get<any>(`/Product/RuleInfo?id=${id}&ApplyArea=${applyarea}`, {
      failTips: false,
    });
  }
  getCreatePolicy(data: any) {
    return this.post<any>(`/FlightPolicy/CreatePolicy`, data);
  }
  getProductList(data: ProductEntity) {
    return this.post<ProductResult<ProductEntity>>(`/product/list`, data);
  }
  getProductGoods(data: any) {
    return this.post<any>(`/product/GetGoods`, data);
  }
  searchPolicyRate(id: string, data: any) {
    return this.post<any>(`/AmendPolicy/CalcPrice/${id}`, data);
  }
  GetChangeOrderPrice(data: any) {
    return this.post<AmendPolicyEntity>(`/amendpolicy/GetChangeOrderPrice`, data);
  }
}
export default new FlightPolicyService("flightPolicy");
